import React from 'react';

import styles from '../FooterSimplified.module.scss';

import Separator from '../../Separator';

const FooterSimplifiedSeparator = () => (
  <div className={styles.footer__separator}>
    <Separator theme="dark" />
  </div>
);

export default FooterSimplifiedSeparator;
